import { render, staticRenderFns } from "./FolderSource.vue?vue&type=template&id=63bad822"
import script from "./FolderSource.vue?vue&type=script&lang=js"
export * from "./FolderSource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports